import React from 'react'
import { CsLoginFooter } from '../footer'
import { CsLoginLogo } from '../login-logo'
import { FreeTrialRegistration } from './free-trial-registration-form'
import { FormattedMessage } from 'react-intl'

export const FreeTrial = () => {
  return (
    <div className="page-update">
      <div className="cs-user-portal-center-top">
        <CsLoginLogo></CsLoginLogo>
        <div className="body free-trial-wrapper">
          <div className="form-container glassy-panel-wrapper-light-inner">
            <div className="no-authenticated-message">
              <div className="title-label">
                <FormattedMessage
                  id="title_configureCredentials"
                  defaultMessage="Configure Credentials"
                />
              </div>
            </div>
            <FreeTrialRegistration />
          </div>
        </div>
      </div>
      <CsLoginFooter></CsLoginFooter>
    </div>
  )
}
